import { NJIcon, NJToggle } from "@engie-group/fluid-design-system-react";
import { setThemePreference, type Theme, useIsDarkMode } from "./theme";

/** Dark mode toggle (legacy parity: `styles/themes/src/themeToggle.tsx`). Reflects the
 * current theme — OS-driven by default — and stores an override when flipped. */
export function ThemeToggle() {
  const isDark = useIsDarkMode();

  return (
    <NJToggle
      id="theme-toggle"
      label="Dark mode"
      className="px-6"
      checked={isDark}
      values={{ off: "dark", on: "light" }}
      onChange={(event) => setThemePreference(event.target.value as Theme)}
    >
      <></>
      <NJIcon size="sm" name="dark_mode" />
    </NJToggle>
  );
}
